import { MimaButton, MimaInput, MimaText } from '../../components';
import { MimaDropdown } from '../../components/Dropdown';
import { useStores } from '../../stores';
import { Formik } from 'formik';
import { toJS } from 'mobx';
import React from 'react';

const StageOne = ({ validationSchema, onSubmit, file, selectClick }) => {
	const {
		appStore: { businessCategories },
	} = useStores();

	// const [files, selectFiles] = useFileUpload();

	return (
		<Formik
			initialValues={{
				address: '',
				bizIndustry: '',
				businessMobile: '',
			}}
			validationSchema={validationSchema()}
			onSubmit={onSubmit}>
			{({
				handleChange,
				handleBlur,
				handleSubmit,
				setFieldValue,
				values,
				errors,
				touched,
			}) => (
				<div>
					<MimaDropdown
						labelTitle="Business Category"
						onChange={data => {
							setFieldValue('bizIndustry', data.key);
						}}
						placeholder="Select a Business Category"
						data={toJS(businessCategories)}
						name="bizIndustry"
						error={errors.bizIndustry}
						touched={touched.bizIndustry}
					/>
					<MimaInput
						type="text"
						labelTitle="Business Phone Number"
						name="businessMobile"
						id="businessMobile"
						value={values.businessMobile}
						onChange={handleChange}
						onBlur={handleBlur}
					/>
					<MimaButton
						title="Select Logo"
						variant="outlined"
						width={38}
						onClick={selectClick}
					/>
					<MimaText
						variant="small"
						mt={2}
						width={38}
						align="center"
						color="var(--color-primary)">
						{file?.name || ''}{' '}
					</MimaText>
					<MimaInput
						type="text"
						labelTitle="Where is your Business Located?"
						placeholder="Business Address"
						name="address"
						id="address"
						error={errors.address}
						touched={touched.address}
						value={values.address}
						onChange={handleChange}
						onBlur={handleBlur}
						mt={2}
					/>

					{/* <div className={styles.form__group}>
						<img
							className={styles.uploadLogo}
							src={files?.source || avartar}
							alt="preview"
						/>

						<MimaButton
							labelTitle="Update your Business Logo(optional)"
							type="button"
							buttonColor="var(--color-primary-3)"
							titleColor="var(--color-dark)"
							onClick={() =>
								selectFiles(
									{ accept: 'image/*' },
									({ name, size, source, file }) => {
										setFieldValue('logo', file);
									}
								)
							}
							title="Upload"
							name="logo"
							id="logo"
							value="Upload"
							mb={2}
						/>
					</div> */}

					{/* <MimaInput
						type="text"
						labelTitle="What's your Instagram handle?(optional)"
						placeholder="Enter your Instagram Handle"
						name="instagram"
						id="instagram"
						value={values.instagram}
						onChange={handleChange}
						onBlur={handleBlur}
					/>

					<MimaInput
						type="text"
						labelTitle="Add your website address(optional)"
						placeholder="Enter your web address"
						name="website"
						id="website"
						value={values.website}
						onChange={handleChange}
						onBlur={handleBlur}
					/> */}
					<MimaButton title="Next" onClick={handleSubmit} mt={2} />
				</div>
			)}
		</Formik>
	);
};

export default StageOne;
